import { render, staticRenderFns } from "./OrgPie.vue?vue&type=template&id=546c89c2&scoped=true&"
import script from "./OrgPie.vue?vue&type=script&lang=js&"
export * from "./OrgPie.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "546c89c2",
  null
  
)

export default component.exports